export const StepIndex = Object.freeze({
  Edit: 0,
  Send: 1,
  Create: 2,
});

export const DocumentType = Object.freeze({
  InvoiceVAT: "vat_invoice",
  InvoiceSalesTax: "sales_tax_invoice",
  Exemption: "exemption",
});
